export const EAgencyContactTitle = {
  "1": "OWNER",
  "2": "STAFF"
};